import { Box, Container, Grid, Typography, Link } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{ bgcolor: "primary.main", color: "white", py: 6, mt: "auto" }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              ANKA BASKI
            </Typography>
            <Typography variant="body2">
              Tekstil baskı sektöründe kaliteli ve profesyonel hizmet
              anlayışıyla hizmet vermekteyiz.
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              Hizmetlerimiz
            </Typography>
            <Typography variant="body2" component="div">
              • Varak Baskı
              <br />
              • Kabartma Baskı
              <br />
              • Flok Baskı
              <br />
              • Sim Baskı
              <br />• Gofre Baskı
              <br />• Pigment Baskı
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom>
              İletişim
            </Typography>
            <Box display="flex" alignItems="center" mb={1}>
              <LocationOnIcon sx={{ mr: 1 }} />
              <Link
                href="https://www.google.com/maps/place/Anka+Bask%C4%B1+D%C3%BCkkan%C4%B1/@40.2043378,28.9016689,15z/data=!4m2!3m1!1s0x0:0x9a747274ba2a4b2d?sa=X&ved=2ahUKEwjF447348L-AhXQ54MGHYQ5B18Q_BJ6BAgIEAE&ictx=111"
                target="_blank"
              >
                <Typography
                  style={{ textDecorationLine: "underline" }}
                  variant="subtitle1"
                  color="white"
                >
                  Bursa, Türkiye
                </Typography>
              </Link>
            </Box>
            <Box display="flex" alignItems="center" mb={1}>
              <PhoneIcon sx={{ mr: 1 }} />
              <Link href="tel:+905393580554">
                <Typography variant="subtitle1" color="white">
                  +90 539 358 05 54
                </Typography>
              </Link>
            </Box>
            <Box display="flex" alignItems="center">
              <EmailIcon sx={{ mr: 1 }} />
              <Link href="mailto:ankabaski.tekstil@gmail.com">
                <Typography variant="subtitle1" color="white">
                  ankabaski.tekstil@gmail.com
                </Typography>
              </Link>
            </Box>
          </Grid>
        </Grid>
        <Typography variant="body2" align="center" sx={{ mt: 4 }}>
          © {new Date().getFullYear()} Anka Baskı. Tüm hakları saklıdır.
        </Typography>
      </Container>
    </Box>
  );
}

export default Footer;
